<template>
  <div class="mingyue-page">
		<div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="banner mingyue_banner">
			<div class="bodyinfo">
				<h2>明月眼镜</h2>
				<p>眼镜行业半产品、产品、检测、打包等工序量身打造</p>
				<!-- <a href="javascript:;" class="case-see-more-btn">查看更多</a> -->
			</div>
		</div>
		<div class="mingyue_body">
			<div class="mingyue1">
				<div class="top">
					<span class="span1">APPLICATION</span>
					<span class="span2">明月眼镜WMS</span>
					<img class="img1" src="../../html/image/mingyue/1.png">
					<span class="span3">进销存工单 库位管理 物料看板</span>
				</div>
			</div>
			<div class="mingyue2">
				<span class="span1">统计报表</span>
				<span class="span2">年、月、日、季度不同时间段内精确绘制出趋势分析图</span>
				<img class="img2" src="../../html/image/mingyue/2.png">
				<img class="img1" src="../../html/image/mingyue/mingyue_img1.png">
			</div>
			<div class="mingyue3">
				<h2>明月眼镜WMS</h2>
				<p>随时跟踪库存走向,帮助把握数据的每一个过程</p>
			</div>
			<div class="mingyue4">	
				<span class="span1">工单类型管理</span>
				<span class="span2">个性化模块设置下,确保条理清晰的单据管理</span>
				<img class="img1" src="../../html/image/mingyue/mingyue_img2.png">
				<img class="img2" src="../../html/image/mingyue/3.png">
			</div>
		</div>
		<Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'

export default {
  name: 'mingyue',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
}
</script>
<style  scoped>
  @import '../../html/css/zkm.css';
  @import '../../html/css/zkm.market.css';
</style>